import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('cpr_admin_token');
    const email = localStorage.getItem('cpr_admin_email');
    if (token && email) {
      setIsAuthenticated(true);
      setAdminEmail(email);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      const { token, email: adminEmail } = response.data;
      localStorage.setItem('cpr_admin_token', token);
      localStorage.setItem('cpr_admin_email', adminEmail);
      setIsAuthenticated(true);
      setAdminEmail(adminEmail);
      return true;
    } catch {
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('cpr_admin_token');
    localStorage.removeItem('cpr_admin_email');
    setIsAuthenticated(false);
    setAdminEmail('');
  };

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, adminEmail, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
